import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var ProductsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default ProductsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Products/ProductsReduxProps.ts
// module id = 115
// module chunks = 0